var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('p',[_vm._v("COMPANY PROFILE")]),_vm._v(" "),_c('h3',[_vm._v("公司简介")]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content clearfix"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.introduce)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145d5f74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/About/Acom/Profile.vue
// module id = null
// module chunks = 